import './style.css'
import { createApp } from 'vue'
import PrimeVue from 'primevue/config'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Select from 'primevue/select'
import preset from './config/primeVuePreset'
import { vueI18n } from './config/vueI18n'
import { initializeSentry } from './config/sentryConfig'
import calcMixin from './helpers/mixin'
import App from './App.vue'

const app = createApp(App)

initializeSentry(app)
app.use(vueI18n())
app.use(PrimeVue, preset)
app.mixin(calcMixin)

app.component('Button', Button)
app.component('InputText', InputText)
app.component('Select', Select)

app.mount('#calc-app')
